import React, { useEffect, useState } from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="container">
    <div className="loader-wrapper">
      <div className="lds-grid">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    </div>
  );
};

export default Loading;
